export type AutoSubmitPostFormArgs = {
  action: string;
  params: { [key: string]: string | number | boolean | undefined | null };
};

export const autoSubmitPostForm = ({ action, params }: AutoSubmitPostFormArgs) => {
  const form = document.createElement('form');
  form.action = action;
  form.method = 'POST';
  form.style.display = 'none';

  Object.entries(params).forEach(([ key, value ]) => {
    if (value !== undefined && value !== null) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = String(value);
      form.appendChild(input);
    }
  });

  document.body.appendChild(form);
  form.submit();
};

